import React, { FC, useMemo } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import {
  DownloadReportProgressCont,
  FileIconCont,
  FileName,
  InProgressLabel,
  SpinIndicatorCont,
} from './DownloadReportProgress.styles';
import { THEME as theme } from '../../../styles/theme';
import ProgressSpinner from '../../ProgressSpinner/ProgressSpinner';
import FileIcon from '@/assets/icons/fileIcon.svg?react';
import SuccessIcon from '@/assets/icons/successFile.svg?react';

const antIconColor = theme.colors.secondary[100];
const antIcon = <LoadingOutlined style={{ fontSize: 32, color: antIconColor }} spin />;

interface IDownloadReportProgress {
  inProgress: boolean;
  downloadFinished: boolean;
  metadata: any;
  lang: string;
}

const DownloadReportProgress: FC<IDownloadReportProgress> = ({
  inProgress,
  downloadFinished,
  metadata,
  lang,
}) => {
  const { t } = useTranslation();
  const prefix = t('pptx.prefix');
  const surveyName = metadata?.survey?.name || 'SurveyName';
  const renderReportProgress = useMemo(
    () => (
      <>
        <InProgressLabel id="InProgressLabel">
          {t('viewSurvey.reportsSetup.downloadModal.title')}
        </InProgressLabel>
        <SpinIndicatorCont id="SpinIndicatorCont">
          {!downloadFinished && <Spin indicator={antIcon} />}
        </SpinIndicatorCont>
        <FileIconCont id="FileIconCont">
          {!downloadFinished ? <FileIcon /> : <SuccessIcon />}
        </FileIconCont>
        <FileName id="FileName">
          {`${prefix}_${surveyName}_${metadata?.group}_${lang}.pptx`}
        </FileName>
        <ProgressSpinner inProgress={inProgress} downloadFinished={downloadFinished} />
      </>
    ),
    [downloadFinished, inProgress, t]
  );
  return (
    <DownloadReportProgressCont id="DownloadReportProgressCont">
      {renderReportProgress}
    </DownloadReportProgressCont>
  );
};

export default DownloadReportProgress;
